import { useParams } from 'react-router-dom';
import { PartnerId } from '../../../models/Integration';
import { getPartnerIdFromIntegrationKey } from '../utils/getPartnerIdFromIntegrationKey';

const usePartnerIdParam = (): PartnerId => {
  const { integration_key } = useParams<{
    integration_key: string;
  }>();

  return getPartnerIdFromIntegrationKey(integration_key);
};

export { usePartnerIdParam };
